<script>
export default {
  methods: {
    // Valida que un array de items tenga la estructura necesaria para ser considerada una estructura Map
    // para este contexto
    // Ejemplo estructura válida {key: 1, value: '2015'}
    // Ejemplo estructura inválida {key: 2, name: '2015'  }
    $_generalValidator_keyValueMapArrayValidator (items) {
      return items.every(x => Object.keys(x).includes('key') && Object.keys(x).includes('value'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/mixins/GeneralValidator.vue